import React, { useContext } from 'react';

import {
  NonCommerceInfoContext,
  ProductContainerContext,
} from '@repo/contexts';
import ProductAddOnCard from './ProductAddOnCard';
import { useUiComponentsInternationalContext } from '@repo/static-translations';

export default function ProductAddOn() {
  // @ts-expect-error until context is converted to TS...KA
  const { isNonCommerce } = useContext(NonCommerceInfoContext);
  // @ts-expect-error until context is converted to TS...KA
  const { product } = useContext(ProductContainerContext);
  const { tt } = useUiComponentsInternationalContext();

  if (isNonCommerce) return null;

  const haveValidProducts = product?.productAddOns?.products?.some(
    p => p.product && p.variant
  );

  return haveValidProducts ? (
    <div className="flex flex-col w-full items-start gap-2">
      <span className="text-base text-foreground font-bold">
        {product.productAddOns?.heading ??
          tt(s => s.productOptionsComponent.purchasedLabel)}
      </span>
      {product?.productAddOns?.products.map(p => (
        <ProductAddOnCard
          itemKey={p._key}
          key={p._key}
          product={p.product}
          variant={p.variant}
        />
      ))}
    </div>
  ) : null;
}
